import styles from './Avatar.module.scss';
import { useCallback, useEffect, useRef, useState } from 'react';
import {
  InitData,
  Avatar as Avatar3D,
  LoadingManager,
  LoadingManagerEvents,
} from '@mavatar/3d-avatar';
import AppLoaderCircle from '@/components/AppLoaderCircle';

interface AvatarProps {
  tools?: any;
  onLoadingError?: (url: string) => void;
}

const Avatar = ({ tools, onLoadingError, ...initData }: InitData & AvatarProps) => {
  const isActive = useRef<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const { onLoading } = initData;

  useEffect(() => {
    isActive.current = true;

    return () => {
      isActive.current = false;
    };
  }, [initData]);

  useEffect(() => {
    const cleanupOnErrorListener = LoadingManager.addEventListener(
      LoadingManagerEvents.ON_ERROR,
      payload => {
        onLoadingError?.(payload.url);
      }
    );

    return () => {
      cleanupOnErrorListener();
    };
  }, [onLoadingError]);

  const onLoadingHendler = useCallback(
    (isLoading: boolean) => {
      if (!isActive.current) {
        return;
      }

      setIsLoading(isLoading);
      onLoading?.(isLoading);
    },
    [onLoading]
  );

  return (
    <div className={styles.container}>
      <Avatar3D {...initData} onLoading={onLoadingHendler} />
      {isLoading && (
        <div className={styles.loader}>
          <AppLoaderCircle />
        </div>
      )}
      <div className={styles.tools}>{tools}</div>
    </div>
  );
};

export default Avatar;
